import { CreateSolutionInstance } from '@/connection/integrations/integrations';
import { serializeError } from '@/store/utils/serialize-error';
import { EMappedIntegrationTypes, ITrayUser } from '@/types/integrations.types';
import { ChannelSettingsReducerCreator } from '../types';

const createSolutionInstanceReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async (
      {
        channel,
        solutionId,
        solutionName,
        type,
        trayUser,
      }: {
        channel: number;
        solutionId: string;
        solutionName: string;
        type: EMappedIntegrationTypes;
        trayUser: ITrayUser;
      },
      { rejectWithValue }
    ) => {
      try {
        const instances = await CreateSolutionInstance(channel, solutionId, solutionName, type, trayUser);
        return instances;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.solutionInstances) {
          state.solutionInstances = [...state.solutionInstances, action.payload.instance];
        }
        state.trayUser = action.payload.user;
        state.instanceToCreate = action.payload.instance;
      },
    }
  );
};

export default createSolutionInstanceReducer;
